import Vue from "vue";
import Vuex from "vuex"
import Customer from "./modules/Alarmsis/Customer"
import Account from "./modules/Alarmsis/Account"
import Defination from "./modules/Defination"
import Dealer from "./modules/Dealer"
import User from "./modules/Users"
import Signal from "./modules/Alarmsis/Signal"
import Reports from "./modules/Reports"
import Socket from "./modules/Socket"
import Ticket from "./modules/Ticket"
import Stock from "./modules/Stock"
import Warehouse from "./modules/Warehouse"
import LDAP from "./modules/LDAP"



Vue.use(Vuex);

export default new Vuex.Store({
    modules:{
        Customer, Defination, Account, Dealer, User, Signal,Reports, Socket, Ticket, Stock, Warehouse, LDAP
    }
}) 


// WEBPACK FOOTER //
// ./src/store/store.js